const checkSessionUrl = '/__check_session_timeout';

const sessionTime = async () => {
  const response = await fetch(checkSessionUrl);
  return response.json();
};

const startSessionTimeout = () => {
  sessionTime()
    .then((data) => {
      if (data.sessionTimeout) {
        const { sessionTimeout } = data;
        return setTimeout(startSessionTimeout, sessionTimeout * 1000);
      }

      if (data.loginUrl) {
        const { loginUrl } = data;
        window.location = `${loginUrl}?returnUrl=${window.location.pathname}`;
      }
    })
    .catch((error) => {
      console.error('Error fetching session timeout data:', error);
    });
};

export default startSessionTimeout;
